import { Injectable } from '@angular/core';
import { ReligionBranch } from '../components/religion-branch/religion-branch.component';
import { ApiService } from '../../../services/api.service';

@Injectable()
export class ReligionBranchServiceService {

  private cache: ReligionBranchSummary[];

  constructor(private apiSvc: ApiService) { }

  public loadEntities(): Promise<ReligionBranchSummary[]> {

    const p = new Promise<ReligionBranchSummary[]>((resolve, reject) => {

      if (this.cache && this.cache.length > 0) {
        console.log("ReligionBranchSummary cache detected");
        resolve(this.cache);
        return;
      }

      this.apiSvc.get("api/religionbranch/GetSummaryList", null).subscribe(
        (data: ReligionBranchSummary[]) => {
          console.log(data);
          this.cache = data;
          resolve(this.cache);
        },
        (err) => {
          console.log("error", err);
        }
      );

    });

    return p;
  }

}

export class ReligionBranchSummary {
  Id: string;
  ReligionBranchType: string;
  Name: string;
}

